<template>
  <footer
    id="footer"
    class="border-t bg-white border-black2 desktop:text-sm mobile:text-xs desktop:py-12 mobile:py-8"
  >
    <modal-policy
      v-if="openModalPolicy"
      :policy="policy"
      @close="openModalPolicy = false"
    />
    <div class="container flex mobile:flex-col">
      <!-- 고객센터 정보 -->
      <section aria-label="고객센터 정보" class="desktop:w-[30%]">
        <div class="mobile:flex mobile:justify-between">
          <img
            src="@/assets/image/dpost.webp"
            class="desktop:w-24 desktop:h-5 mobile:w-16 mobile:h-3"
            alt="로고"
          />
          <div class="flex desktop:hidden">
            <img
              src="@/assets/image/icon/ic_insta.svg"
              class="w-6 h-6 cursor-pointer"
              alt="인스타그램 아이콘"
              @click="moveToUrl(url.instagram)"
            />
            <img
              src="@/assets/image/icon/ic_blog.svg"
              class="w-6 h-6 cursor-pointer ml-[10px]"
              alt="블로그 아이콘"
              @click="moveToUrl(url.blog)"
            />
          </div>
        </div>

        <div class="mobile:flex justify-between">
          <div class="flex-col">
            <div class="desktop:mt-7 mobile:mt-4 text-primary font-semibold">
              {{ t("footer.help-center") }}
            </div>

            <div class="text-black7">
              <div>{{ t("footer.help-call") }}</div>
              <div>
                {{
                  t("footer.help-email", { email: "dposthelp@dvercorp.co.kr" })
                }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 서비스 약관 및 서비스 정보 -->
      <section class="mobile:mt-5 desktop:w-[60%]" aria-label="회사 정보">
        <div class="flex">
          <a href="https://www.dvercorp.co.kr" 
              class="font-normal text-black7" target="_blank">
            {{ t("footer.company-info") }}
          </a>
          <div
            class="mx-5 cursor-pointer font-normal text-black7"
            @click="
              policyUpdate('service');
              openModalPolicy = true;
            "
          >
            {{ t("footer.trems-of-service") }}
          </div>
        
          <a href="https://static.dpost.co.kr/privacy-policy/latest/" 
              class="font-bold text-black9" target="_blank">
            {{ t("footer.privacy-policy") }}
          </a>
        </div>

        <div class="desktop:mt-7 mobile:mt-4 text-black7">
          <div class="desktop:flex">
            <div>
              {{ t("footer.company-info1") }} |
              {{ t("footer.company-info2") }} |
              {{ t("footer.company-info3") }}
              <span class="mobile:hidden"> | </span>
            </div>
            <div class="desktop:ml-1">
              {{ t("footer.company-info4") }} |
              {{ rev }}
            </div>
          </div>
          <div>{{ t("footer.company-location") }}</div>
          <div>
            <a href="https://www.dvercorp.co.kr" target="_blank">
              {{ t("footer.company-copyright") }}
            </a>
          </div>
        </div>
      </section>
      <section class="flex-col desktop:w-[10%] mobile:hidden">
        <div class="flex justify-end">
          <img
            src="@/assets/image/icon/ic_insta.svg"
            class="w-6 h-6 cursor-pointer"
            alt="인스타그램 아이콘"
            @click="moveToUrl(url.instagram)"
          />
          <img
            src="@/assets/image/icon/ic_blog.svg"
            class="w-6 h-6 cursor-pointer ml-[10px]"
            alt="블로그 아이콘"
            @click="moveToUrl(url.blog)"
          />
        </div>
      </section>
    </div>
  </footer>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import ModalPolicy from "@/components/modal/policy.vue";
import dayjs from "@/utils/dayjs";

const { t } = useI18n();

const policy = ref<policyType>("service");

const policyUpdate = (value: policyType) => {
  if (value === "service")
    policy.value = dayjs().isAfter("2023-11-20") ? "serviceNew" : value;
  else policy.value = value;
};

const openModalPolicy = ref<boolean>(false);

const url = {
  instagram: "https://www.instagram.com/dpost_official_/",
  blog: "https://www.dpost.blog/",
};

const rev = __APP_VERSION__;

const moveToUrl = (url: string) => {
  window.open(url);
};
</script>
<style lang="scss"></style>
